<!--
 * @Author: yangliwei 1280426581@qq.com
 * @Date: 2025-01-02 19:07:03
 * @LastEditTime: 2025-12-19 16:56:14
 * @LastEditors: YangLiwei 1280426581@qq.com
 * @FilePath: \Mall-Vue\src\components\Search.vue
 * Copyright (c) 2025 by yangliwei, All Rights Reserved.
 * @Description:
-->
<template>
  <div class="headercon">
    <img
      src="static/img/logo.png"
      alt="logo"
      style="display:block;margin:0 auto;width: 100px;"
    />
    <div class="container">
      <i-input
        v-model="sreachData"
        size="large"
        class="sreach"
        placeholder="输入你想查找的商品"
      >
        <Button slot="append" icon="ios-search" @click="sreach"></Button>
      </i-input>
      <Tag
        v-for="(item, index) in promotionTags"
        :key="index"
        closable
        @on-close="closeTags(index)"
        ><span @click="selectTags(index)">{{ item }}</span></Tag
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      sreachData: '',
      promotionTags: [
        '买2免1',
        '领200神券',
        '199减100',
        '母婴5折抢',
        '充100送20'
      ]
    };
  },
  methods: {
    closeTags (index) {
      this.promotionTags.splice(index, 1);
    },
    selectTags (index) {
      this.sreachData = this.promotionTags[index];
    },
    sreach () {
      this.$router.push({
        path: '/goodsList',
        query: { sreachData: this.sreachData }
      });
    }
  }
};
</script>

<style scoped>
.headercon {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 1300px;
  margin: 0 auto;
}
.container {
  padding-top: 15px;
  margin: 0px auto;
  margin-bottom: 15px;
  width: 460px;
}
.sreach {
  margin: 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue